<mat-form-field class="chip-list" appearance="standard">
  
  <mat-chip-list #chipList aria-label="Tag selection">
    <mat-chip *ngFor="let tag of assignedTags"
      [style.background-color]="tag.backgroundColour"
      [style.color]="color(tag.backgroundColour)"
      (removed)="removeTag(tag)">
      <span>{{tag.name}}</span>
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <input class="add-chip"
      #tagInput 
      name="addTag"
      placeholder="add tag" 
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="addTag($event)">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="autoCompleteSelected($event)">
    <mat-option *ngFor="let tag of filteredTags()" [value]="tag">
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="m-r-10 chart-select-color" [style.background-color]="tag.backgroundColour"></div>
        <div>{{tag.name}}</div>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
